import { Button, ButtonStyles, Popup } from '@silverfort/sf-components';
import React from 'react';
import { useHistory } from 'react-router-dom';


const Content =() => (
    <div className='content-center font-sf font-normal'>Our Events Email Sending and sending to Syslog can now be configured under the <span className='font-medium'>“Notifications tab”</span></div>
);

const Footer = ({onCancel, onApprove}) => (
    <div className="flex flex-1 justify-end gap-2 ">
        <Button
            buttonStyle={ButtonStyles.GhostSolid}
            text="Cancel"
            onClick={onCancel}
        />
        <Button buttonStyle={ButtonStyles.PrimarySolid} text="Go To Notifications Tab" onClick={onApprove}/>
    </div>
);

const EventSending = ({ open, onClose }) => {
    const history = useHistory();

    const handleNavigation = () => {
        history.push('/Settings/Notifications#email');
    };

    return (
        <Popup open={open}
               title={'Email Events Sending'}
               ContentComponent={Content}
               FooterComponent={Footer}
               onClose={onClose}
               onCancel={onClose}
               onApprove={handleNavigation}
               popupClassName={'!w-[368px] h-[240px]'}
        />
    )
}

export default EventSending;